module.exports = __webpack_public_path__ + "static/media/Letterhead_01.639428b5.jpg";